export enum ListsPermissions {
  ProcessJuniorList = 'process-junior-list',
  ProcessProfileList = 'process-profile-list',
  ListAliases = 'list-aliases',
  CDelivery = 'c-delivery',
}